module.exports = function getResource(label, vars = []) {
    const resources = {
        status: 'Status',
        seeTrackingDetails: 'See tracking details',
        shippingMethod: 'Shipping Method',
        estimatedDelivery: 'Estimated Delivery',
        tracking: 'Tracking #',
        deliverTo: 'Deliver To',
        billingInfo: 'Billing Info',
        paypalAccount: 'PayPal Account',
        applePay: 'Apple Pay',
        shipment: 'SHIPMENT',
        needToReturnSomething: 'Need to return something?',
        changedYourMind: 'Changed your mind?',
        cancelYourOrder: 'Cancel your order',
        paidWith: 'Paid with ',
        shipTo: 'Ship To',
        shipToFeDexLocation: 'Shipping to FedEx Pickup Location',
        deliveryBy: 'Delivery By',
        autoReplenish: 'Auto-Replenish',
        manageSubscriptions: 'Manage Subscriptions',
        bannerButton: 'Sign Up for Text Alerts',
        bannerTitle: 'Be the first to know what’s new.',
        bannerParagraph: 'Never miss out on exclusives releases, events, and offers.',
        bannerRates: '*Msg & data rates may apply.'
    };

    return resources[label];
};
